/* Inline description wrapper only. The shared configurator remains in msc-configurator.js. */
(() => {
  'use strict';
  const assets = new Map();
  function load(url, type) {
    if (assets.has(url)) return assets.get(url);
    const pending = new Promise((resolve, reject) => {
      const node = document.createElement(type === 'css' ? 'link' : 'script');
      if (type === 'css') {
        node.rel = 'stylesheet';
        node.href = url;
      } else {
        node.src = url;
        node.async = false;
      }
      node.onload = resolve;
      node.onerror = () => reject(new Error('Configurator asset unavailable'));
      document.head.appendChild(node);
    });
    assets.set(url, pending);
    return pending;
  }
  document.querySelectorAll('[data-msc-product]').forEach(details => {
    if (details.dataset.bound) return;
    details.dataset.bound = 'true';
    const summary = details.querySelector('summary');
    const status = details.querySelector('[role="status"]');
    let started = false;
    details.addEventListener('toggle', async () => {
      summary.setAttribute('aria-expanded', String(details.open));
      if (!details.open || started) return;
      started = true;
      status.textContent = 'Loading configurator…';
      details.setAttribute('aria-busy', 'true');
      try {
        if (document.getElementById('msc')) throw new Error('Configurator already present');
        await Promise.all([load(details.dataset.css, 'css'), load(details.dataset.catalog, 'js')]);
        details.querySelector('[data-msc-mount]').appendChild(
          details.querySelector('[data-msc-template]').content.cloneNode(true)
        );
        await load(details.dataset.app, 'js');
        if (!details.querySelector('#msc-sum-title')?.textContent.trim()) {
          throw new Error('Configurator did not initialize');
        }
        status.textContent = '';
        status.hidden = true;
      } catch (error) {
        status.textContent = '';
        status.hidden = true;
        details.querySelector('.msc-product__fallback').hidden = false;
      } finally {
        details.removeAttribute('aria-busy');
      }
    });
  });
})();
